// removed by extract-text-webpack-plugin
module.exports = {"main":"_3rPJmRge3zWemK5zOJfo_7","scroller":"_2vikgt01nsW25SEDtf1skl","footer":"_2_JvSQX1aicL5AF44uSJzo","modalWrapper":"_92kt6A1RfbeTgUCsOSpNf","ctaButtonWrapper":"_1G1XV-F2sAmvhJ2JLWUihQ","modalLabel":"iH0zHgX4UbveXCh2K_K38","urlLabel":"DydCG1fKAa-Eoi849yMFy","deleteButton":"_3sn3p77oO071rIOXm3GMqM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/profile.scss
// module id = 467
// module chunks = 0